import React from 'react';
import './SearchResults.css';

function SearchResults({ onReportSelect, billingRecords }) {
  const hasRawResults = Array.isArray(billingRecords) && billingRecords.length > 0;

  const hasBalance = (record) =>
    record.tInsp > 0 ||
    record.pInsp > 0 ||
    record.rInsp > 0 ||
    record.sInsp > 0 ||
    record.nhdRpt > 0 ||
    record.tRepairs > 0 ||
    record.rRepairs > 0 ||
    record.sRepairs > 0 ||
    record.hhRepairs > 0;

  const hasAnyBalanceDue = hasRawResults && billingRecords.some(hasBalance);

  const renderCard = (record) => {
    return (
      <div
        key={record.rptID}
        className="result-card"
        onClick={() => onReportSelect(record)}
      >
        <div className="card-row">
          <span className="card-label">Report ID:</span>
          <span className="card-value">{record.rptID}</span>
        </div>
        <div className="card-row">
          <span className="card-label">Order Date:</span>
          <span className="card-value">{new Date(record.origOrderDate).toLocaleDateString()}</span>
        </div>
        <div className="card-row">
          <span className="card-label">Address:</span>
          <span className="card-value">{record.address}</span>
        </div>
        <div className="card-row">
          <span className="card-label">City:</span>
          <span className="card-value">{record.city}</span>
        </div>
        <div className="card-row">
          <span className="card-label">State:</span>
          <span className="card-value">{record.state}</span>
        </div>
        <div className="card-row">
          <span className="card-label">ZIP:</span>
          <span className="card-value">{record.zipid}</span>
        </div>
      </div>
    );
  };

  return (
    <section className="search-results">
      <h2>Search Results</h2>

      {hasRawResults ? (
        <div>
          <p>
            {hasAnyBalanceDue
              ? 'The following reports match your search criteria. Please click on the row with the correct order date and address to view any balances due.'
              : 'No balances due for this search criteria.'}
          </p>
          
          {/* Mobile Card Layout */}
          <div className="results-cards">
            {billingRecords.map(renderCard)}
          </div>
          
          {/* Desktop Table Layout */}
          <div className="results-table">
            <table>
              <thead>
                <tr>
                  <th>Report ID</th>
                  <th>Order Date</th>
                  <th>Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>ZIP</th>
                </tr>
              </thead>
              <tbody>
                {billingRecords.map((record) => {
                  return (
                    <tr
                      key={record.rptID}
                      className="selectable-row"
                      onClick={() => onReportSelect(record)}
                      style={{
                        cursor: 'pointer',
                      }}
                    >
                      <td>{record.rptID}</td>
                      <td>{new Date(record.origOrderDate).toLocaleDateString()}</td>
                      <td>{record.address}</td>
                      <td>{record.city}</td>
                      <td>{record.state}</td>
                      <td>{record.zipid}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <p className="no-results">No results found. Please adjust your search criteria.</p>
      )}
    </section>
  );
}

export default SearchResults;
